import { Reveal } from "@/components/Reveal";

export default function Founder() {
  return (
    <section id="founder" className="bg-wash py-[88px]">
      <div className="mx-auto max-w-[1160px] px-6">
        <div className="flex items-start gap-6">
          <Reveal>
            <span
              data-testid="founder-monogram"
              className="shrink-0 w-14 h-14 rounded-full bg-navy text-white font-extrabold text-lg flex items-center justify-center"
            >
              SR
            </span>
          </Reveal>
          <div>
            <Reveal>
              <p className="text-xs font-bold uppercase tracking-[0.25em] text-safety mb-4">Founder</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h3 className="text-2xl md:text-3xl font-extrabold text-navy max-w-2xl leading-snug">
                Built by a working safety professional in Abilene, Texas.
              </h3>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-5 max-w-2xl text-base text-steel leading-relaxed">
                Sean Rawlins founded WorkSafeAgent to put a person and a closed loop behind every camera
                alert.{" "}
                <a href="/services" data-testid="founder-services-link" className="font-bold text-safety hover:text-[#d97c12] transition-colors">
                  His individual credentials are listed on the Services page →
                </a>
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <ul className="mt-6 space-y-3 max-w-2xl" data-testid="founder-record">
                <li className="flex items-start gap-3 text-sm text-ink leading-relaxed">
                  <span className="w-1.5 h-1.5 bg-safety rounded-full mt-2 shrink-0" />
                  Led safety for 300+ technicians across 1M+ man-hours at a 0.86 TRIR on the largest AI data center build in the US
                </li>
                <li className="flex items-start gap-3 text-sm text-ink leading-relaxed">
                  <span className="w-1.5 h-1.5 bg-safety rounded-full mt-2 shrink-0" />
                  Safety on an 800 MW utility-scale solar project
                </li>
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
